__turbopack_context__.v({
  "container": "styles-module-scss-module__invW-W__container",
  "promoContent": "styles-module-scss-module__invW-W__promoContent",
});
